import { Suspense, useEffect, useRef } from "react";
import DataLoader from "../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import Buttons from "../../components/ui/button/Buttons";
import { EventListFilterFormData, eventListTableConfig } from "./data/EventList.Data";
import { useState } from "react";
import { paginationObj } from '../../utils/Constants'
import FinalMolGrid from "../../components/FinalMolGrid/FinalMolGrid";
import { setAllDropDownFieldsBatch } from "../../utils/FormFields/FieldsSetting/SetFieldSetting";
import FormCreator from "../../components/forms/FormCreator";
import SwalAlert from "../../services/swalService/SwalService";
import { useDeleteEventDetailsByIdMutation, useGetEventDetailListMutation, useLazyGetAllDropDownForEventManagementQuery } from "../../app/services/EventManagement/ViewEditEvent/ViewEditEventApi";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import CancelBookingEvent from "./component/CancelBookingEvent/CancelBookingEvent";
import { useDownloadBookingSheetByEventIdMutation, useLazyDownloadBookingSheetByEventIdQuery } from "../../app/services/EventManagement/EventManagementApi";
import { saveAs } from 'file-saver';
import { encryptAES } from "../../services/CryptoService";
import { UrlIdEncrypt, encryptAESID } from "../../utils/Encryption";

const ViewEditEventManagementList = () => {
  const viewEditRef = useRef();
  const molGridRef = useRef();
  const [viewEditEventManagement, setViewEditEventManagement] = useState(EventListFilterFormData);
  const [dataSource, setDataSource] = useState();
  const { confirm, success, error } = SwalAlert()
  const [pagination, setPagination] = useState({
    ...paginationObj,
    SearchText: "",
    StatusId: 0,
    HiddenSearch: "",
  });

  const [isModelOpen, setIsModalOpen] = useState(false);

  const viewListDropDowns = [
    { dropdownName: "Status", fieldId: "status" },
  ];

  const [getViewEdiEventManagement, { isLoading: viewListIsLoading, data: EventviewListData, isSuccess: viewListIsSuccess }] = useGetEventDetailListMutation();
  const [geEventListDropDown, { isLoading: viewEventListDropDownIsLoading, data: viewEventListDropDownData, isSuccess: viewEvenetListDropDownIsSuccess }] = useLazyGetAllDropDownForEventManagementQuery();
  const [deleteEventDetailsById, { isSuccess: deleteEventDetailIsSuccess, data: deleteEventDetailData }] = useDeleteEventDetailsByIdMutation();
  // const [DownloadBookingSheetByEventId, { isSuccess: isSuccessDownloadBookingSheetByEventId, isLoading: isLoadingDownloadBookingSheetByEventId, data: DownloadBookingSheetByEventIdData }] = useLazyDownloadBookingSheetByEventIdQuery();
  const [DownloadBookingSheetByEventId, { isSuccess: isSuccessDownloadBookingSheetByEventId, isLoading: isLoadingDownloadBookingSheetByEventId, data: DownloadBookingSheetByEventIdData }] = useLazyDownloadBookingSheetByEventIdQuery();


  // useEffects

  useEffect(() => {
    if (!isLoadingDownloadBookingSheetByEventId && isSuccessDownloadBookingSheetByEventId && DownloadBookingSheetByEventIdData) {
    }
  }, [isLoadingDownloadBookingSheetByEventId, isSuccessDownloadBookingSheetByEventId, DownloadBookingSheetByEventIdData]);

  useEffect(() => {
    if (!viewListIsLoading && EventviewListData && viewListIsSuccess) {
      setDataSource(EventviewListData.itemList)
      setPagination(prev => {
        return { ...prev, totalCount: EventviewListData.totalCount }
      });
    }
  }, [viewListIsLoading, EventviewListData, viewListIsSuccess]);

  // Effect for set dropdown
  useEffect(() => {
    if (!viewEventListDropDownIsLoading && viewEvenetListDropDownIsSuccess && viewEventListDropDownData) {
      // Updates dropdown fields in the form based on the fetched data
      setAllDropDownFieldsBatch(EventListFilterFormData, viewListDropDowns, viewEventListDropDownData);
    }
  }, [viewEventListDropDownIsLoading, viewEvenetListDropDownIsSuccess, viewEventListDropDownData]);

  useEffect(() => {
    geEventListDropDown();
    getViewListData(pagination);
  }, []);

  useEffect(() => {
    if (deleteEventDetailIsSuccess && deleteEventDetailData) {
      if (deleteEventDetailData.hasError === false) {
        success("Email Deleted Successfully");
        getViewListData(pagination);
      }
      else {
        error(deleteEventDetailData.errorMessage)
      }
    }
  }, [deleteEventDetailIsSuccess, deleteEventDetailData]);

  const getViewListData = (data) => {
    getViewEdiEventManagement(data);
  }

  const handlePageChange = (page) => {
    const { pageNumber, pageSize } = page;
    getViewListData({ ...pagination, pageSize: pageSize, pageNo: pageNumber })
  };

  const searchClick = () => {
    let formData = viewEditRef?.current?.getFormData();
    let request = {
      ...paginationObj,
      SearchText: formData?.eventName || null,
      StatusId: formData?.status?.value || formData?.status,
      HiddenSearch: formData.hidden?.label || '',
    }
    setPagination(prev => { return { ...prev, ...request } });
    getViewListData(request);
  };

  const handleDelete = (data) => {
    confirm('Delete', "Are you sure you want to delete", 'Yes', 'Cancel')
      .then(value => {
        if (value) {
          const request = {
            id: data.eventId,
            deletedBy: 115,
            appId: 1
          }
          deleteEventDetailsById(request)
        }
      })
  }

  const handleCancle = () => {
    setIsModalOpen(!isModelOpen)
  }

  const openCloseModal = () => {
    setIsModalOpen(!isModelOpen);
  };

  const handleDownload = async (dataa) => {
    debugger
    console.log(dataa)
    alert("Download")
    try {
      const id = encryptAES(dataa?.eventId);
      const id2 = encryptAES(dataa?.eventTimeSlotId);

      const response = await DownloadBookingSheetByEventId(
        {
          eventId: id,
          eventTimeSlotId: id2,
        }
      );
      if (response && response.originalArgs) {
        const { fileName } = response.originalArgs;
        const blob = new Blob([response.data.fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, fileName || 'download.xlsx');
      }
    } catch (error) {
      console.error('Error downloading the file:', error);
    }
  }

  const handleURLClick = (data) => {
    window.open(`http://localhost:3001/eventDetails/workshop/${UrlIdEncrypt(data.eventId)}`)
  }

  const actionHandler = {
    //  EDIT: handleEditClick,
    DELETE: handleDelete,
    Cancel: handleCancle,
    Download: handleDownload,
    URLLink: handleURLClick
  };
  return (<>
    <div>
      <div className="membership-application">
        <div className="form-card">
          {viewEventListDropDownData &&
            <Suspense fallback={<DataLoader />}>
              <div className="">
                <FormCreator
                  config={viewEditEventManagement}
                  ref={viewEditRef}
                  key={false}
                // onActionChange={handleActionChange}
                />
                <div className="col-lg-12 btn-sec mt-2">
                  <Buttons
                    onClick={searchClick}
                    buttonText={"Search"}
                    buttonTypeClassName="theme-btn btn mt-auto"
                    isLoading={false}
                  />
                </div>
              </div>
            </Suspense>
          }
          <div>
            <h5>Total Count : {pagination.totalCount}</h5>
          </div>
          <div className="table-100 mt-4">
            <FinalMolGrid
              ref={molGridRef}
              configuration={eventListTableConfig}
              dataSource={dataSource}
              isLoading={viewListIsLoading}
              allowPagination={true}
              pagination={pagination}
              onActionChange={actionHandler}
              onPageChange={handlePageChange}
            />
            {isModelOpen && <CenterModel
              modelTitle={'Cancel Booking'}
              show={"test"}
              handleClose={openCloseModal}
              onUpload={openCloseModal}
            >
              <CancelBookingEvent />
            </CenterModel>
            }
          </div>
        </div>
      </div>
    </div>
  </>)
}
export default ViewEditEventManagementList;